import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {CommonModule} from '@angular/common';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Product} from '../../model/product';
import {selectProductById} from './catalog-product.reducer';

@Pipe({
  name: 'getProductById'
})
export class GetProductByIdPipe implements PipeTransform {

  constructor(
    private store: Store<any>
  ) {
  }

  transform(productId: string): Observable<Product> {
    return this.store.pipe(
      select(selectProductById(productId))
    );
  }

}

@NgModule({
  declarations: [
    GetProductByIdPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    GetProductByIdPipe
  ],
  providers: [
    GetProductByIdPipe
  ]
})

export class GetProductByIdPipeModule {
}
